export const fonts = {
  main: 'Mabry Pro',
}

export const colors = {
  white: '#fff',
  black: '#000',
  blueDark: '#000082',
  blueDark4: '#00008264',
  gray: '#ECE6E0', // More of a sand
  grayLight: '#666666',
  greenDark: '#0B4141',
  greenDarkest: '#5F6368',
  border: '#c3c3c3',
  dark8: 'rgba(0, 0, 0, 0.8)',
  dark7: 'rgba(0, 0, 0, 0.7)',
  dark6: 'rgba(0, 0, 0, 0.6)',
  dark5: 'rgba(0, 0, 0, 0.5)',
  dark4: 'rgba(0, 0, 0, 0.4)',
  red: '#DF1919',
  pink: '#FFDFE9',
  greenDark4: '#0B414164',
}

export const breakpoints = {
  xs: 576,
  desktop: 768,
  sm: 900,
  md: 992,
  xl: 1200,
  xxl: 1484,
}
